import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import {Glyphicon, Modal, Button, ButtonToolbar} from "react-bootstrap";
import UserHandler from "js/utilities/user-handler";
import Zoom from "js/utilities/zoom-handler";
import Api from "js/utilities/fnapi-client";
import Amplitude from "js/utilities/amplitude";
import { Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import UserTable from "../account/account-table-user";
import UserTableRow from "../account/account-table-user-row";
import ApplicationTable from "../account/account-table-application";
import ApplicationTableRow from "../account/account-table-application-row";
import Spinner from "../elements/spinner"
import StaticField from "../account/account-form-static";
import FontAwesome from "react-fontawesome";
import ChecklistRow from "../account/checklist-row";

export default React.createClass({

  /*********************************************************************************************************************
   Screen configuration
   I think, not positive if all of this is necessary
   *********************************************************************************************************************/

  displayName: "account",
  contextTypes: {
    router: React.PropTypes.object.isRequired
  },
  scrollToGuide : null,
  scrollingEl: null,

  /*********************************************************************************************************************
   Render methods
   *********************************************************************************************************************/

  render: function() {

    this.includeHeaderFooter = true;
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">

            {(!this.state.accountInfo && this.state.noAccess) &&
              <div id="page-loading">
                <p><strong>Access to your account has been revoked by your organization.</strong></p>
                <p>Please reach out to your organization contact and ask her/him to grant you access.</p>
                <p>If you believe this to be in error, please&nbsp;
                  <a href="mailto:support@facetec.com?subject=SDK%20Site%20Feedback&body=Hello%20FaceTec%20Support%2C%0A%0AI%27ve%20received%20an%20error%20stating%20that%20my%20account%20access%20has%20been%20revoked.%0A%0A%3CPlease%20describe%20your%20scenario%20and%20suggested%20resolution%3E%0A%0AThank%20you">contact us</a>.
                </p>
              </div>
            }

            {( !this.state.accountInfo && !this.state.noAccess ) &&
              <div id="page-loading">
                <FontAwesome name="circle-o-notch" className="fa-spin fa-3x green" />
                <span id="page-loading-text">Loading your account...</span>
              </div>
            }

            {this.state.accountInfo &&

              <div id="account-info">

                {/* Account section */}
                <section>
                  <div className="title">
                    <Glyphicon glyph="cog"/>
                    <h2 id="account">Account</h2>
                    <p>Access your account, configure your Apps, and retrieve your Licenses.</p>
                    <hr/>
                  </div>

                  <div className="form-table">
                    <StaticField
                      label="Your Email"
                      value={this.state.accountInfo.user.email }
                    />
                  </div>


                  {(!this.state.accountInfo.company.hasLicensedApplication || !this.state.accountInfo.company.hasApplicationPreparedForProduction) && this.state.accountInfo.company.applications.length >= 1 &&
                    <div>
                      { !this.state.accountInfo.company.serverAccessEnabled &&
                        <div>
                          <p><strong>Checklist to Download the FaceTec Server SDK:</strong></p>
                          <div className="checklist-table">
                            <ChecklistRow
                              label="Step 1 - Download and test FaceTec in the Sample Apps. Integrate FaceTec into your Application."
                              status={this.state.accountInfo.company.hasApplicationUsage}
                              offDescription="Before requesting FaceTec Server SDK access, you must first download and test FaceTec."
                              ready={true}
                            />
                            <ChecklistRow
                              label="Step 2 - Configure Your Application App ID(s) and/or Domains Below."
                              status={this.state.accountInfo.company.hasApplicationPreparedForDomains}
                              offDescription="Click your application below and configure your App ID(s) and/or Domains."
                              ready={true}
                            />
                            <ChecklistRow
                              label="Step 3 - Commercial Agreement must be signed."
                              status={this.state.accountInfo.company.serverAccessEnabled}
                              offDescription="Server SDK access is only provided AFTER a Commercial Agreement is signed."
                              ready={true}
                              action={<Link to='/quote' target="_blank">Request a Pricing Quote Here.</Link>}
                            />
                          </div>
                        </div>
                      }
                      {!this.state.accountInfo.company.hasLicensedApplication && !this.state.accountInfo.company.logsFound && this.state.accountInfo.company.serverAccessEnabled &&
                        <div>
                          <p><strong>Checklist for Going Live and Into Production with Real Users:</strong></p>
                          <div className="checklist-table">
                            <ChecklistRow
                              label={!this.state.accountInfo.company.serverAccessEnabled?"Configure your App below.": "Configure your App below."}
                              status={this.state.accountInfo.company.logsFound}
                              offDescription="Configure your SSH Keys and Daily Usage Log Uploads."
                              ready={this.state.accountInfo.company.hasApplicationPreparedForProduction}
                              action={<Link to='/going-production-overview' target="_blank">Read more about Going Production.</Link>}
                            />
                            <ChecklistRow
                              label={!this.state.accountInfo.company.serverAccessEnabled?"Send a message to your FaceTec Contact once everything is  configured.": "Send a message to your FaceTec Contact once everything is  configured."}
                              status={this.state.accountInfo.company.hasLicensedApplication}
                              offDescription="Once you have completed all of the above, we can issue you final licenses."
                              ready={this.state.accountInfo.company.logsFound}
                              action={<span></span>}
                            />
                          </div>
                        </div>
                      }
                    </div>
                  }

                </section>
                <section>
                  <h3 id="applications">Your Apps Using FaceTec</h3>

                  <div className="sub-section company-applications">
                    { this.state.accountInfo.sharedApplications.length >= 1 && <h4>Account applications</h4> }
                    { this.accountApplicationSection() }
                  </div>

                  {this.state.accountInfo.sharedApplications.length >= 1 &&
                    <div className="sub-section shared-applications">
                        <h4>External Apps you can access</h4>
                        <p>
                          <em>
                            You have been granted direct access to { this.state.accountInfo.sharedApplications.length } application{ this.state.accountInfo.sharedApplications.length >1 ? 's' : '' } not owned by your account.
                          </em>
                        </p>
                        <ApplicationTable
                          row={ApplicationTableRow}
                          dataSource={this.state.accountInfo.sharedApplications}
                          canAdministerUsers={false}
                          canEdit={false}
                          showApplicationRoles={false}
                        />
                    </div>
                  }

                </section>

                {/* The company users row */}
                {this.state.accountInfo.user.roles.indexOf("ADMINISTER_USERS") > -1 && this.state.accountInfo.company.users.length &&

                <section id="user-section">
                  <h3 id="users">Your Users</h3>
                  <UserTable row={UserTableRow} dataSource={this.state.accountInfo.company.users} entityType="company"/>
                </section>
                }
              </div>
            }

            <SDKSidebar menuType="account" title="Account"/>

          </div>
        </div>
      </div>
    );
  },


  /*********************************************************************************************************************
   Built-in react methods
   *********************************************************************************************************************/

  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      noAccess: false,
      accountInfo: null, // Stores the main account response from the API
      newUserPermissions: { // The permissions assigned to any new user
        view: true,
        edit: true,
        administerUsers: false
      },
      creatingApplication: false,
      organizationExists: null,
      newApplicationName: "",
      submittingApplication: false,
      applicationCreationError: "",
      scrollToElement: scrollToElement,
      deepLinkTimeout: 1000
    }
  },

  componentDidMount: function() {
    mountCode(this);
    this.fetchCompany();
  },

  componentWillMount() {
    Zoom.getVersion(this);
    this.includeHeaderFooter = true;
    Amplitude.send("amplitude-test");
    if (!UserHandler.loggedIn()) {
      return this.context.router.push("/signin");
    }

    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },
  /*********************************************************************************************************************
   Account/Company level methods
   *********************************************************************************************************************/

  // Gets *all* of the account data from api.zoomauth
  fetchCompany: function() {
    Api.get("account").then(( response ) => {
      this.setState({accountInfo: response.data});
      UserHandler.setHasEnteredProduction(response.data.company.hasEnteredProduction);
    }).catch( (error) => {
      // Not sure if there is a better way to catch messages/subcodes from ZAPI?
      if (error.message == 'You do not have access to this endpoint.'){
        this.setState({
          noAccess: true
        })
      } else {
        return this.context.router.push("/signin");
      }
    });
  },

  /*********************************************************************************************************************
   User management methods
   *********************************************************************************************************************/

  // The checked permissions for new users are stored in state, when a checkbox is clicked this toggles that checkbox
  toggleNewUserPermission: function(perm){
    var tempNewUserPermissions = this.state.newUserPermissions;
    tempNewUserPermissions[perm] = false;
    this.setState({newUserPermissions: tempNewUserPermissions});
  },

  /*********************************************************************************************************************
   Application Display and Management incl. Create Application Flow
   *********************************************************************************************************************/

  // @TODO: Should every section be broken out to its own function like this?
  accountApplicationSection: function( ) {

    // Account has applications already
    if (this.state.accountInfo.company.applications.length >= 1){
      return <ApplicationTable
        row={ApplicationTableRow}
        company={this.state.accountInfo.company}
        dataSource={this.state.accountInfo.company.applications}
        canEdit={this.state.accountInfo.user.roles.indexOf("EDIT") > -1}
        canAdministerUsers={this.state.accountInfo && this.state.accountInfo.user.roles.indexOf("ADMINISTER_USERS") > -1}
        showApplicationRoles={this.state.accountInfo.company.showApplicationRoles}
        logsFound={this.state.accountInfo.company.logsFound}
      />
    }

    // Account does not have applications, only show section if user has permission to edit
    if (this.state.accountInfo.user.roles.indexOf("EDIT") > -1){

      // If we're currently in the process of creating an application
      if (this.state.creatingApplication){
        return this.createApplicationProcess();
      }

      return <p>You don't have any Apps using FaceTec yet. Click the button below to create your first FaceTec Development Key  so you can add FaceTec to your Apps!<br /><br /><Button bsStyle="primary" style={{width: "100%"}} onClick={ this.toggleCreatingApplication }>Click to Add FaceTec to Your First App</Button></p>;
    }

    return <p>Your account does not have any Apps.</p>;
  },

  createApplicationProcess: function(){

    var content;

    // Organization has no applications, if we ever want to allow orgs to create more than one app we should examine this
    //if (this.state.accountInfo.company.applications.length < 1 ){}

    // We haven't determined if they have another account yet, lets try to funnel them to their team
    if (this.state.organizationExists == null){
      content = (
        <div>
          <p><strong>Does your organization already have a FaceTec account?</strong></p>
          <ButtonToolbar>
            <Button variant="success" onClick={ () => { this.setOrganizationExists(true); } }>
              Yes
            </Button>
            <Button variant="primary" onClick={ () => { this.setOrganizationExists(false); } }>
              No
            </Button>
            <Button variant="primary" onClick={ () => { this.setOrganizationExists(false); } }>
              Not sure
            </Button>
          </ButtonToolbar>
        </div>
      );
    }

    else if (this.state.organizationExists){
      content = (
        <div>
          <p><strong>Please reach out to your Organization's contact and ask her/him to use this page to invite you to their FaceTec Account.</strong></p>
          <ButtonToolbar>
            <Button variant="success" onClick={ () => { this.toggleCreatingApplication(); } }>
              Done
            </Button>
          </ButtonToolbar>
        </div>
      );
    }

    else if (!this.state.organizationExists){
      content = (
        <div>
          <div className="form-group">
            <p>Enter Application Name:</p>
            <input type="text" placeholder="My Organization's Application" defaultValue={this.state.newApplicationName} onChange={ this.updateNewApplicationName } autoFocus />
          </div>

          { this.state.submittingApplication &&
          <ButtonToolbar>
            <Button variant="success" disabled={ true }>
              <FontAwesome name="circle-o-notch" className="fa-spin green" /> Creating Application
            </Button>
          </ButtonToolbar>
          }

          { !this.state.submittingApplication &&
          <ButtonToolbar>
            <Button variant="success" onClick={ () => { this.submitCreateApplication(); } } disabled={ this.state.newApplicationName.length < 3 }>
              Create App
            </Button>
            <Button variant="secondary" onClick={ () => { this.toggleCreatingApplication(); } }>
              Cancel
            </Button>
          </ButtonToolbar>
          }

          {this.state.applicationCreationError != "" ? <p className="error-message">{this.state.applicationCreationError}</p> : "" }

        </div>
      );
    }

    return (
      <div className="well">
        {content}
      </div>
    );
  },

  updateNewApplicationName(e){
    this.setState({
      newApplicationName: e.target.value,
    });
  },

  toggleCreatingApplication: function(){
    let status = this.state.creatingApplication;

    // We're starting the process...for now...reset the "organization has applications" setting
    // We may not want to do this, to help prevent people from changing their mind and creating apps "anyway"
    if (status == false){
      this.setState({
        organizationExists: null
      })
    }
    this.setState({
      creatingApplication: !status
    })
  },

  setOrganizationExists: function(organizationExists){
    this.setState({
      organizationExists: organizationExists
    })
  },

  submitCreateApplication: function(){

    let newApplicationPayload = {
      name: this.state.newApplicationName
    };

    this.setState({
      submittingApplication: true,
      applicationCreationError: ""
    });


    Api.post('application', newApplicationPayload).then((response) => {

      this.setState({
        submittingApplication: false,
        newApplicationName: '',

      });

      if (!response.meta || !response.meta.ok) {
        if (response.meta.ok === false) {
          this.setState({applicationCreationError: "Error: " + response.meta.message});
        }
        return;
      }

      if (!response || !response.data) {
        this.setState({applicationCreationError: "Sorry, an unknown error has occurred"});
        return;
      }

      // If we made it this far, we're pretty sure we're happy
      var accountInfo = this.state.accountInfo;

      // Add the new application to the company applications
      accountInfo.company.applications.push(
        response.data
      );

      // Update the state and close the process
      this.setState({
        accountInfo: accountInfo,
        creatingApplication: false
      });

    });
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/account.jsx